import PropTypes from 'prop-types';
import React from 'react';
import { capitalize } from 'lodash-es';
import { Box, Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsPanelProperty } from '@marvelapp/ui-internal';
import Measurement from '../../containers/handoff/Measurement';
export default function PanelTypography(props) {
    var panelItems = getPanelItems(props);
    return (React.createElement(SpecsPanel, { title: "Typography" },
        React.createElement(Flex, { flexWrap: "wrap", marginBottom: -3 }, panelItems.map(function (_a) {
            var label = _a.label, value = _a.value, _b = _a.itemProps, itemProps = _b === void 0 ? {} : _b;
            return (React.createElement(Box, { key: label, marginBottom: 20, width: itemProps.width || 1 / 2 },
                React.createElement(SpecsPanelProperty, { isDisabled: itemProps.isDisabled, label: label }, value),
                itemProps.isSeparate && (React.createElement(Box, { bg: "smoke", height: "1px", marginTop: 20, width: 1 }))));
        }))));
}
function getPanelItems(_a) {
    var align = _a.align, autoLineHeight = _a.autoLineHeight, fontFamily = _a.fontFamily, fontSize = _a.fontSize, italic = _a.italic, letterSpacing = _a.letterSpacing, lineHeight = _a.lineHeight, strikethrough = _a.strikethrough, subFamily = _a.subFamily, textStyle = _a.textStyle, underline = _a.underline;
    var panelItems = [
        {
            label: 'Typeface',
            value: fontFamily,
        },
        {
            label: 'Font Size',
            value: React.createElement(Measurement, { isText: true, value: fontSize }),
        },
        {
            label: 'Align',
            value: capitalize(align),
        },
    ];
    if (subFamily) {
        panelItems.push({
            label: 'Font Weight',
            value: subFamily,
        });
    }
    if (textStyle) {
        panelItems.unshift({
            label: 'Text Style',
            value: textStyle,
            itemProps: {
                width: 1,
                isDisabled: true,
                isSeparate: true,
            },
        });
    }
    if (letterSpacing !== 0) {
        panelItems.push({
            label: 'Letter Spacing',
            value: React.createElement(Measurement, { isText: true, value: letterSpacing }),
        });
    }
    if (lineHeight) {
        panelItems.push({
            label: 'Line Spacing',
            value: autoLineHeight ? ('Auto') : (React.createElement(Measurement, { isText: true, value: lineHeight })),
        });
    }
    if (underline) {
        panelItems.push({
            label: 'Text Decoration',
            value: 'Underline',
        });
    }
    else if (strikethrough) {
        panelItems.push({
            label: 'Text Decoration',
            value: 'Strikethrough',
        });
    }
    if (italic) {
        panelItems.push({
            label: 'Font Style',
            value: 'Italic',
        });
    }
    return panelItems;
}
/* eslint-disable react/no-unused-prop-types */
PanelTypography.propTypes = {
    align: PropTypes.string.isRequired,
    fontFamily: PropTypes.string.isRequired,
    fontSize: PropTypes.number.isRequired,
    italic: PropTypes.bool.isRequired,
    letterSpacing: PropTypes.number,
    lineHeight: PropTypes.number,
    strikethrough: PropTypes.bool.isRequired,
    subFamily: PropTypes.string,
    underline: PropTypes.bool.isRequired,
};
